import { render, staticRenderFns } from "./DialogResetaSenha.vue?vue&type=template&id=ce1c375a&"
import script from "./DialogResetaSenha.vue?vue&type=script&lang=js&"
export * from "./DialogResetaSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports